import { api } from '../axiosClient';
import type {
  CreateFilterViewPayload,
  FilterView,
  FilterViewsResponse,
  UpdateFilterViewPayload,
} from './filterViews.types';

const filterViewsPath = (pageIdentifier: string) =>
  `/pages/${pageIdentifier}/filterViews`;

/**
 * Get all filter views for a page
 * GET /pages/{pageIdentifier}/filterViews
 */
export const getFilterViews = (
  pageIdentifier: string,
): Promise<FilterViewsResponse> => {
  return api.get(filterViewsPath(pageIdentifier));
};

/**
 * Get a single filter view by ID
 * GET /pages/{pageIdentifier}/filterViews/{id}
 */
export const getFilterView = (
  pageIdentifier: string,
  id: string,
): Promise<FilterView> => {
  return api.get(`${filterViewsPath(pageIdentifier)}/${id}`);
};

/**
 * Create a new filter view
 * POST /pages/{pageIdentifier}/filterViews
 */
export const createFilterView = (
  pageIdentifier: string,
  data: CreateFilterViewPayload,
): Promise<FilterView> => {
  return api.post(filterViewsPath(pageIdentifier), data);
};

/**
 * Update an existing filter view
 * PUT /pages/{pageIdentifier}/filterViews/{id}
 */
export const updateFilterView = (
  pageIdentifier: string,
  id: string,
  data: UpdateFilterViewPayload,
): Promise<FilterView> => {
  return api.put(`${filterViewsPath(pageIdentifier)}/${id}`, data);
};

/**
 * Delete a filter view
 * DELETE /pages/{pageIdentifier}/filterViews/{id}
 */
export const deleteFilterView = (
  pageIdentifier: string,
  id: string,
): Promise<void> => {
  return api.delete(`${filterViewsPath(pageIdentifier)}/${id}`);
};
